import { getWmPoiId } from '@utils/ids';
import { getStorage, setStorage } from '@utils/localStorage';

const updateParentOrderCount = (payload: { [index: string]: string }) => {
    const data = { ...payload, handlerType: 'orderCountChangeFromChild' };
    parent.postMessage(JSON.stringify(data), '*');
};

const updateParentOrderCountNew = (type: string) => {
    const data = { type, handlerType: 'updateOrderCountFromChild' };
    parent.postMessage(JSON.stringify(data), '*');
};

/**
 * 小票打印时机选项
 *
 * - `order-confirm-only` 仅接单时打印
 * - `all` 接单和提醒备餐时打印
 */
export type PrintTimingSettingOption = 'order-confirm-only' | 'all';

const printTimingSettingKey = 'print-timing';

/**
 * 传门店 id 时取指定门店的配置（主要用于全部门店下获取特定门店的配置），
 * 不传门店 id 时取当前门店的配置。
 */
export const getPrintTimingSetting = (wmPoiId?: string): PrintTimingSettingOption => {
    return getStorage(`${printTimingSettingKey}-${wmPoiId || getWmPoiId()}`) === 'all'
        ? 'all'
        : 'order-confirm-only';
};

export const setPrintTimingSetting = (option: PrintTimingSettingOption) => {
    setStorage(`${printTimingSettingKey}-${getWmPoiId()}`, option);
};

// eslint-disable-next-line import/prefer-default-export
export { updateParentOrderCount, updateParentOrderCountNew };
